module.exports = __webpack_public_path__ + "static/media/sbornik.0998d7b6.pdf";